import DashBoardProvider from 'components/provider/dashboard-provider'
import { useAuth } from 'contexts/auth'
import { ProjectProvider } from 'contexts/project'
import useAxiosInterceptor from 'interceptors/unauthorized'
import Certificate from 'pages/authentication/certificate'
import CertificateUpload from 'pages/authentication/certificate-upload'
import Collaborators from 'pages/authentication/collaborators'
import ConnectedCertificate from 'pages/authentication/connected-certificate'
import DatasourceConnect from 'pages/authentication/datasource-connect'
import EmailCheck from 'pages/authentication/email-check'
import EmailConfirmation from 'pages/authentication/email-confirmation'
import EsocialConnect from 'pages/authentication/esocial-connect'
import ForgotPassword from 'pages/authentication/forgot-password'
import Home from 'pages/authentication/home'
import InviteResponsible from 'pages/authentication/invite-responsible'
import InviteResponsibleSuccess from 'pages/authentication/invite-responsible-success'
import LetterOfAttorneyEsocial from 'pages/authentication/letter-of-attorney-esocial'
import ListMultipleOrganizaTions from 'pages/authentication/list-multiple-organizations'
import Profile from 'pages/authentication/profile'
import Redirect from 'pages/authentication/redirect'
import RequestPermission from 'pages/authentication/request-permision'
import ResetPassword from 'pages/authentication/reset-password'
import SignIn from 'pages/authentication/sign-in'
import SignUpExternal from 'pages/authentication/sign-up-external'
import SignUpMultiple from 'pages/authentication/sign-up-multiple'
import Store from 'pages/authentication/store'
import Terms from 'pages/authentication/terms'
import VerifyEmail from 'pages/authentication/verify-email'
import Authentications from 'pages/automation/authentications'
import AuthenticationBox from 'pages/automation/authentications/authentication-box'
import CadastralDifferences from 'pages/automation/cadastral-differences'
import CadastralPosition from 'pages/automation/cadastral-position'
import CofreDigital from 'pages/automation/cofre-digital'
import CofreDigitalTableInfo from 'pages/automation/cofre-digital/cofre-digital-table-info'
import CofreDigitalTablePreview from 'pages/automation/cofre-digital/table-preview'
import ConduccoConnectorForm from 'pages/automation/conducco-connector/form'
import ConduccoConnectorList from 'pages/automation/conducco-connector/list'
import ConnectorPermissionForm from 'pages/automation/connector-permission/form'
import ConnectorPermissionList from 'pages/automation/connector-permission/list'
import ConnectorTypeForm from 'pages/automation/connector-type/form'
import ConnectorTypeList from 'pages/automation/connector-type/list'
import Contracts from 'pages/automation/contracts'
import ContractView from 'pages/automation/contracts/view'
import ControlPannel from 'pages/automation/control-pannel'
import CustomConnectorForm from 'pages/automation/custom-connector/form'
import CustomConnectorList from 'pages/automation/custom-connector/list'
import ProjectExecution from 'pages/automation/project-execution'
import ProjectExecutionForm from 'pages/automation/project-execution/form'
import ProjectExecutionList from 'pages/automation/project-execution/list'
import ConnectorConnect from 'pages/automation/project/connect'
import ProjectList from 'pages/automation/project/list'
import TablePreviewHandler from 'pages/automation/project/table-preview-handler'
import ProjectView from 'pages/automation/project/view'
import ProjectAppsView from 'pages/automation/project/view/apps'
import RecipeExecutionLogForm from 'pages/automation/recipe-execution-log/form'
import RecipeExecutionLogList from 'pages/automation/recipe-execution-log/list'
import RecipePermissionForm from 'pages/automation/recipe-permission/form'
import RecipePermissionList from 'pages/automation/recipe-permission/list'
import RecipeForm from 'pages/automation/recipe/form'
import RecipeList from 'pages/automation/recipe/list'
import StandardConnectorForm from 'pages/automation/standard-connector/form'
import StandardConnectorList from 'pages/automation/standard-connector/list'
import CommercialPlanForm from 'pages/commercial/commercial-plan/form'
import CommercialPlanList from 'pages/commercial/commercial-plan/list'
import InvoiceForm from 'pages/commercial/invoice/form'
import InvoiceList from 'pages/commercial/invoice/list'
import PaymentGatewayForm from 'pages/commercial/payment-gateway/form'
import PaymentGatewayList from 'pages/commercial/payment-gateway/list'
import CityForm from 'pages/common/city/form'
import CityList from 'pages/common/city/list'
import CountryForm from 'pages/common/country/form'
import CountryList from 'pages/common/country/list'
import NotFound from 'pages/common/not-found'
import StateForm from 'pages/common/state/form'
import StateList from 'pages/common/state/list'
import ThemeEditForm from 'pages/common/theme/edit'
import ThemeForm from 'pages/common/theme/form'
import ThemeList from 'pages/common/theme/list'
import ThemePreviewForm from 'pages/common/theme/preview'
import CustomerPermissionForm from 'pages/operation/customer-permission/form'
import CustomerPermissionList from 'pages/operation/customer-permission/list'
import CustomerForm from 'pages/operation/customer/form'
import CustomerList from 'pages/operation/customer/list'
import EmailLogForm from 'pages/operation/email-log/form'
import EmailLogList from 'pages/operation/email-log/list'
import EmailForm from 'pages/operation/email/form'
import EmailList from 'pages/operation/email/list'
import InviteForm from 'pages/operation/invite/form'
import InviteList from 'pages/operation/invite/list'
import NotificationList from 'pages/operation/notification/list'
import BlockReasonForm from 'pages/security/block-reason/form'
import BlockReasonList from 'pages/security/block-reason/list'
import MenuOptionForm from 'pages/security/menu-option/form'
import MenuOptionList from 'pages/security/menu-option/list'
import ModuleForm from 'pages/security/module/form'
import ModuleList from 'pages/security/module/list'
import NavigationForm from 'pages/security/navigation/form'
import NavigationList from 'pages/security/navigation/list'
import OrganizationForm from 'pages/security/organization/form'
import OrganizationList from 'pages/security/organization/list'
import ProfileOptionForm from 'pages/security/profile-option/form'
import ProfileOptionList from 'pages/security/profile-option/list'
import ProfileForm from 'pages/security/profile/form'
import ProfileList from 'pages/security/profile/list'
import UserGroupForm from 'pages/security/user-group/form'
import UserGroupList from 'pages/security/user-group/list'
import UserProfileForm from 'pages/security/user-profile/form'
import UserProfileList from 'pages/security/user-profile/list'
import UserForm from 'pages/security/user/form'
import UserList from 'pages/security/user/list'
import { Switch } from 'react-router-dom'
import Route from './route'
import { ComplementaryData } from 'pages/operation/complementary-data'
import ContractViewOld from 'pages/automation/contracts/viewOLD'
import Activities from 'pages/automation/contracts/page-activities'

import { Movimentacao2, Movimentacao, WorkspaceActivity, WorkspaceListContracts, WorkspaceListActivities, WorkspaceList } from "v2/pages/Workspace";
import { PortfolioPage as OperationalPanelPortfolioPage, CnpjPage as OperationalPanelCnpjPage, WorkspacePage as OperationalPanelWorkspacePage } from "v2/pages/OperationalPanel";
import { CreateWorkspace } from 'v2/pages/Setup'
import { CreateWorkspaces } from 'v2/pages/Setup/CreateWorkspaces'
import { WorkspaceListBuyerSeller } from 'v2/pages/Workspace/WorkspaceListBuyerSeller'
import { EditWorkspace } from 'v2/pages/Setup/EditWorkspace'
import { Adesao } from 'v2/pages/Workspace/Activity/Adesao'
import { Excecao } from 'v2/pages/Workspace/Activity/Excecao'
import { MissingData } from 'v2/pages/Workspace/Activity/MissingData'
import { MissingDataForm as Old } from 'v2/pages/MissingDataForm'
import { MissingDataForm } from 'v2/pages/MissingDataFormulary'
import { PlanExtensionForm } from 'v2/pages/PlanExtensionFormulary'
import { Exclusion } from 'v2/pages/Workspace/Activity/Exclusion'
import { PosicaoCadastral } from 'v2/pages/Workspace/Activity/PosicaoCadastral'
import { BateCadastral } from 'v2/pages/Workspace/Activity/BateCadastral'
import { Campanhas } from 'v2/pages/Workspace/Activity/Campanhas'
import { ExportarMovimentacao } from 'v2/pages/Workspace/Activity/ExportarMovimentacao'
import { PJs } from 'v2/pages/Workspace/Activity/PJs'
import { Collaborators as CollaboratorsV2 } from 'v2/pages/Collaborators'
import { Dashboard } from 'v2/pages/Dashboard'
import { InsightsPage } from 'v2/pages/Insights'
import { ManualInclusion } from 'v2/pages/Workspace/Activity/ManualInclusion'
import { TemplateDataGovernance } from 'v2/pages/Workspace/Activity/TemplateDataGovernance'
import { TemplateMovements, TemplateMovementsExportMovements } from 'v2/pages/Workspace/Activity/TemplateMovements'
import { AppEditData } from 'v2/pages/Workspace/Activity/AppEditData'
import { AppCampaign } from 'v2/pages/Workspace/Activity/AppCampaign'
import { AppUploadLayout } from 'v2/pages/Workspace/Activity/AppUploadLayout'
import { AppManualInsert } from 'v2/pages/Workspace/Activity/AppManualInsert'
import { AppInclusion } from 'v2/pages/Workspace/Activity/AppInclusion'
import { AppExclusion } from 'v2/pages/Workspace/Activity/AppExclusion'
import { AppChange } from 'v2/pages/Workspace/Activity/AppChange'
import { AppQbemApi } from 'v2/pages/Workspace/Activity/AppQbemApi'
import { TemplateMovementsCheck } from 'v2/pages/Workspace/Activity/TemplateMovementsCheck'
import { TemplateMovementsExport } from 'v2/pages/Workspace/Activity/TemplateMovementsExport'
import { EditWorkspaceLife } from 'v2/pages/Setup/EditWorkspaceLife'
import { Clients } from 'v2/pages/Clients'
import { PainelGovernanca } from 'modules/governance/pages/PainelGovernanca'

const { VITE_APP_AMBIENT } = import.meta.env

const Routes = () => {
  useAxiosInterceptor()
  const { user } = useAuth()

  return (
    <Switch>
      <Route
        // Manter
        path='/'
        exact
        component={SignIn}
      />

      {/* <Route
        path='/signup'
        component={SignUp}
      /> */}

      <Route
        // Manter
        path='/external/signup/:code'
        component={SignUpExternal}
      />

      <Route
        // Manter
        path='/signup-invite/:token'
        component={SignUpMultiple}
      />

      <Route
        // Manter
        path='/guest-signup/:token'
        component={CertificateUpload}
      />

      <Route
        // Manter
        path='/forgot-password'
        component={ForgotPassword}
      />

      <Route
        // Manter
        path='/reset-password'
        component={ResetPassword}
      />

      <Route
        // Manter
        path='/email-check'
        component={EmailCheck}
      />

      <Route
        // Manter
        path='/confirm-email/:token'
        component={SignIn}
      />

      <Route
        // Manter
        path='/email-confirmation'
        component={EmailConfirmation}
      />

      <Route
        // Manter
        path='/redirect'
        component={Redirect}
        isPermission
      />

      <Route
        // Manter
        path='/verify-email'
        component={VerifyEmail}
        isPermission
      />

      <Route
        // Manter
        path='/terms-and-conditions'
        component={Terms}
        isPermission
      />

      <Route
        // Manter
        path='/datasource-connect'
        component={DatasourceConnect}
        isPermission
      />

      <Route
        // Manter
        path='/esocial-connect'
        component={EsocialConnect}
        isPermission
      />

      <Route
        // Manter
        path='/invite-responsible'
        component={InviteResponsible}
        isPermission
      />

      <Route
        // Manter
        path='/invite-responsible-success'
        component={InviteResponsibleSuccess}
        isPermission
      />

      <Route
        // Manter
        path='/certificate-upload'
        component={CertificateUpload}
        isPermission
      />

      <Route
        // Manter
        path='/certificate-upload-guest/:token'
        component={CertificateUpload}
      />

      <Route
        // Manter
        path='/loa-esocial'
        component={LetterOfAttorneyEsocial}
        isPermission
      />

      <Route
        // Manter
        path='/request-permission'
        component={RequestPermission}
        isPermission
      />

      <Route
        // Manter
        path='/select-organization'
        component={ListMultipleOrganizaTions}
        isPermission
      />

      <Route
        // Manter
        path='/connected-certificate'
        isPermission
        component={ConnectedCertificate}
      />

      <Route
        // Verificar
        path='/cadastral-position'
        component={CadastralPosition}
        isExternal
      />

      <Route
        // Verificar
        path='/cadastral-difference'
        component={CadastralDifferences}
        isExternal
      />

      <Route
        // Manter
        exact
        path='/form/:workspaceActivityId/:campaignId'
        component={MissingDataForm}
        isExternal
      />

      <Route
        // Manter
        exact
        path='/extensao/:token'
        component={PlanExtensionForm}
        isExternal
      />

      <Route
        // Manter
        exact
        path='/home'
        component={Home}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover
        exact
        path='/dashboard'
        component={Dashboard}
        // component={DashBoardProvider}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/v2/dashboard'
        component={Dashboard}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/store'
        component={Store}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/collaborators'
        component={CollaboratorsV2}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/insights'
        component={InsightsPage}
        isPrivate
        useDefaultLayout
      />

      <Route
        exact
        path='/governance/panel'
        component={PainelGovernanca}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        exact
        path='/profile'
        component={Profile}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        path='/certificate'
        component={Certificate}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/organizations'
        component={OrganizationList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/organizations/new'
        component={OrganizationForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/organizations/edit/:id'
        component={OrganizationForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/block-reasons'
        component={BlockReasonList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/block-reasons/new'
        component={BlockReasonForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/block-reasons/edit/:id'
        component={BlockReasonForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/user-groups'
        component={UserGroupList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/user-groups/new'
        component={UserGroupForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/user-groups/edit/:id'
        component={UserGroupForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/users'
        component={UserList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/users/new'
        component={UserForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/users/edit/:id'
        component={UserForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/modules'
        component={ModuleList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/modules/new'
        component={ModuleForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/modules/edit/:id'
        component={ModuleForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/menu-options'
        component={MenuOptionList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/menu-options/new'
        component={MenuOptionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/menu-options/edit/:id'
        component={MenuOptionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        exact
        path='/profiles'
        component={ProfileList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        exact
        path='/profiles/new'
        component={ProfileForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        path='/profiles/edit/:id'
        component={ProfileForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/profile-options'
        component={ProfileOptionList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/profile-options/new'
        component={ProfileOptionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/profile-options/edit/:id'
        component={ProfileOptionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/users-profiles'
        component={UserProfileList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/users-profiles/new'
        component={UserProfileForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/users-profiles/edit/:id'
        component={UserProfileForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/navigations'
        component={NavigationList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/navigations/new'
        component={NavigationForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/navigations/edit/:id'
        component={NavigationForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/countries'
        component={CountryList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/countries/new'
        component={CountryForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/countries/edit/:id'
        component={CountryForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/states'
        component={StateList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/states/new'
        component={StateForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/states/edit/:id'
        component={StateForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/cities'
        component={CityList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/cities/new'
        component={CityForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/cities/edit/:id'
        component={CityForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        exact
        path='/themes'
        component={ThemeList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        exact
        path='/themes/configure'
        component={ThemeForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        exact
        path='/themes/edit'
        component={ThemeEditForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar
        exact
        path='/themes/preview'
        component={ThemePreviewForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/payment-gateways'
        component={PaymentGatewayList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/payment-gateways/new'
        component={PaymentGatewayForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/payment-gateways/edit/:id'
        component={PaymentGatewayForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/commercial-plans'
        component={CommercialPlanList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/commercial-plans/new'
        component={CommercialPlanForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/commercial-plans/edit/:id'
        component={CommercialPlanForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/invoices'
        component={InvoiceList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/invoices/new'
        component={InvoiceForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/invoices/edit/:id'
        component={InvoiceForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/customers'
        component={CustomerList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/customers/new'
        component={CustomerForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        path='/customers/edit/:id'
        component={CustomerForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/customer-permissions'
        component={CustomerPermissionList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/customer-permissions/new'
        component={CustomerPermissionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/customer-permissions/edit/:id'
        component={CustomerPermissionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar (Verificar Convite Admin > Seller)
        exact
        path='/invites'
        component={InviteList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar (Verificar Convite Admin > Seller)
        exact
        path='/invites/new'
        component={InviteForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar (Verificar Convite Admin > Seller)
        path='/invites/edit/:id'
        component={InviteForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/emails'
        component={EmailList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/emails/new'
        component={EmailForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/emails/edit/:id'
        component={EmailForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/email-logs'
        component={EmailLogList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/email-logs/new'
        component={EmailLogForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/email-logs/edit/:id'
        component={EmailLogForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter (Quando clica no sininho de notificacao)
        exact
        path='/notifications'
        component={NotificationList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/connector-types'
        component={ConnectorTypeList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/connector-types/new'
        component={ConnectorTypeForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/connector-types/edit/:id'
        component={ConnectorTypeForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/standard-connectors'
        component={StandardConnectorList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/standard-connectors/new'
        component={StandardConnectorForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/standard-connectors/edit/:id'
        component={StandardConnectorForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/custom-connectors'
        component={CustomConnectorList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/custom-connectors/new'
        component={CustomConnectorForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/custom-connectors/edit/:id'
        component={CustomConnectorForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/conducco-connectors'
        component={ConduccoConnectorList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/conducco-connectors/new'
        component={ConduccoConnectorForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/conducco-connectors/edit/:id'
        component={ConduccoConnectorForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/recipes'
        component={RecipeList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/recipes/new'
        component={RecipeForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/recipes/edit/:id'
        component={RecipeForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/recipes-execution-logs'
        component={RecipeExecutionLogList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/recipes-execution-logs/new'
        component={RecipeExecutionLogForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/recipes-execution-logs/edit/:id'
        component={RecipeExecutionLogForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/recipes-permissions'
        component={RecipePermissionList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/recipes-permissions/new'
        component={RecipePermissionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/recipes-permissions/edit/:id'
        component={RecipePermissionForm}
        isPrivate
        useDefaultLayout
      />

      {VITE_APP_AMBIENT !== 'prod' && (
        <Route
          exact
          path='/control-pannel'
          component={ControlPannel}
          isPrivate
          useDefaultLayout
        />
      )}

      {user?.isAdmin && (
        <Route
          exact
          path='/v2/painel-operacional'
          component={OperationalPanelPortfolioPage}
          isPrivate
          useDefaultLayout
        />
      )}

      {user?.isAdmin && (
        <Route
          exact
          path='/v2/painel-operacional/cnpj/:federalTaxId'
          component={OperationalPanelCnpjPage}
          isPrivate
          useDefaultLayout
        />
      )}

      {user?.isAdmin && (
        <Route
          exact
          path='/v2/painel-operacional/workspace/:workspaceId/atividade/:activityId'
          component={OperationalPanelWorkspacePage}
          isPrivate
          useDefaultLayout
        />
      )}

      <Route
        // Manter
        exact
        path='/authentications'
        component={Authentications}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/authentications/:id/:name'
        component={AuthenticationBox}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/cofre-digital'
        component={CofreDigital}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/cofre-digital/info/:id'
        component={CofreDigitalTableInfo}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path='/cofre-digital/table/preview/:id/:snowflakeTableId'
        component={CofreDigitalTablePreview}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/project-executions/:id'
        component={ProjectExecution}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/project-executions'
        component={ProjectExecutionList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/project-executions/new'
        component={ProjectExecutionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/project-executions/edit/:id'
        component={ProjectExecutionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/connectors-permissions'
        component={ConnectorPermissionList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        exact
        path='/connectors-permissions/new'
        component={ConnectorPermissionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Remover (usado apenas ADMIN)
        path='/connectors-permissions/edit/:id'
        component={ConnectorPermissionForm}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
        exact
        path='/contract/:organizationId'
        component={Contracts}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
        exact
        path='/contract/:organizationId/:contractId/:tagId'
        component={ContractViewOld}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
        exact
        path='/contract/movimentacao/:organizationId/:contractId/:tagId'
        component={ContractView}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
        exact
        path='/contract/:organizationId/:contractId'
        component={Activities}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
        exact
        path='/projects/table/:id/:snowflakeTableId/:organizationId'
        component={TablePreviewHandler}
        isPrivate
        useDefaultLayout
      />

      <Route 
        // Manter
        exact
        path="/clients"
        component={Clients}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path="/contracts"
        component={WorkspaceList}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path="/v2/organizations/contracts/:sellerId/:buyerId"
        component={WorkspaceListBuyerSeller}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:buyerId/create"
        component={CreateWorkspaces}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/edit"
        component={EditWorkspace}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/edit-life"
        component={EditWorkspaceLife}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/organizations/:organizationId/workspaces"
        component={WorkspaceListContracts}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId"
        component={WorkspaceListActivities}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/movimentacao"
        component={Movimentacao}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/data-governance"
        component={TemplateDataGovernance}
        isPrivate
        useDefaultLayout
      />
      <Route
        // Manter
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/movements-check"
        component={TemplateMovementsCheck}
        isPrivate
        useDefaultLayout
      />
      <Route
        // Manter
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/movements-export"
        component={TemplateMovementsExport}
        isPrivate
        useDefaultLayout
      />
      <Route
        // Manter
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/app_edit_data/:workspaceActivityId"
        component={AppEditData}
        isPrivate
        useDefaultLayout
      />
      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/app_campaign/:workspaceActivityId"
        component={AppCampaign}
        isPrivate
        useDefaultLayout
      />
      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/app_upload_layout/:workspaceActivityId"
        component={AppUploadLayout}
        isPrivate
        useDefaultLayout
      />
      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/app_manual_insert/:workspaceActivityId"
        component={AppManualInsert}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/app_inclusion/:workspaceActivityId"
        component={AppInclusion}
        isPrivate
        useDefaultLayout
      />
      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/app_exclusion/:workspaceActivityId"
        component={AppExclusion}
        isPrivate
        useDefaultLayout
      />
      <Route
        // Manter
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/app_change/:workspaceActivityId"
        component={AppChange}
        isPrivate
        useDefaultLayout
      />
      <Route
        exact
        path="/v2/workspaces/:workspaceId/qbem-api-config"
        component={AppQbemApi}
        isPrivate
        useDefaultLayout
      />
      {/*
        Both QBem activity URLs (file_upload and direct) currently render the
        credentials config form. Configuring credentials IS the only interaction
        these activities expose at the moment — execution happens server-side
        when the user clicks "Exportar" on the parent workspace.
        AppQbemApi reads workspaceId from the route and resolves the connector
        config by buyerOrganizationId, so templateId and workspaceActivityId
        params are intentionally unused here. Activity-specific dashboards
        (e.g. carga history per activity) are out of scope for this PR.
      */}
      <Route
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/qbem_api_file_upload/:workspaceActivityId"
        component={AppQbemApi}
        isPrivate
        useDefaultLayout
      />
      <Route
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/qbem_api_direct/:workspaceActivityId"
        component={AppQbemApi}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/adesao/:workspaceActivityId"
        component={Adesao}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/campanhas/:workspaceActivityId"
        component={Campanhas}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter    
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/exportar-movimentacao/:workspaceActivityId"
        component={ExportarMovimentacao}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter    
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/pjs"
        component={PJs}
        isPrivate
        useDefaultLayout
      />
      
      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/dados-faltantes/:workspaceActivityId"
        component={MissingData}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/exclusion/:workspaceActivityId"
        component={Exclusion}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/posicao-cadastral/:workspaceActivityId"
        component={PosicaoCadastral}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/bate-cadastral/:workspaceActivityId"
        component={BateCadastral}
        isPrivate
        useDefaultLayout
      />

      <Route
        // Manter 
        exact
        path="/v2/workspaces/:workspaceId/templates/:templateId/excecao/:workspaceActivityId"
        component={Excecao}
        isPrivate
        useDefaultLayout
      />

      <ProjectProvider>
        <Route
          // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
          exact
          path='/projects'
          component={ProjectList}
          isPrivate
          useDefaultLayout
        />

        <Route
          // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
          exact
          path='/projects/:id/:organizationId/:contractId'
          component={ProjectView}
          isPrivate
          useDefaultLayout
        />

        <Route
          // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
          path='/projects/:id/setup/:key'
          component={ConnectorConnect}
          isPrivate
          useDefaultLayout
        />

        <Route
          // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
          path='/projects/:id/app/:appId/:organizationId/:contractId'
          component={ProjectAppsView}
          isPrivate
          useDefaultLayout
        />

        <Route
          // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
          path='/projects/activities/:id/app/:appId/:organizationId/:contractId/:templateRecipeId'
          component={ProjectAppsView}
          isPrivate
          useDefaultLayout
        />

        <Route
          // Verificar (Rotas antigas das atividades, não estão sendo mais utilizadas porém vale dar um double check)
          path='/projects/movimentacao/:id/app/:appId/:organizationId/:contractId/:tagId'
          component={ProjectAppsView}
          isPrivate
          useDefaultLayout
        />
      </ProjectProvider>

      <Route
        // Manter
        path='*'
        component={NotFound}
        isPrivate
      />
    </Switch>
  )
}

export default Routes
